import { cmsApiClient } from '@/config/httpClients';
import type { PrimaryNavigationItem } from './schemas';
import { PrimaryNavigationSchema } from './schemas';

const getPrimaryNavigation = async () => {
  const response = await cmsApiClient
    .get<{ data: PrimaryNavigationItem[] }>(`navs/primary_navigation/tree`)
    .json();
  const safeParseResponse = PrimaryNavigationSchema.safeParse(response);
  if (!safeParseResponse.success) {
    //TODO: Log error to Sentry
    console.error(
      'Error validating getPrimaryNavigation',
      safeParseResponse.error
    );
    //Lie to TS in case of any runtime validation errors
    return response.data as PrimaryNavigationItem[];
  } else {
    return response.data;
  }
};

export { getPrimaryNavigation };
